// extracted by mini-css-extract-plugin
export default {"container":"Team_container__FzbS+","team":"Team_team__XExWj","image":"Team_image__eNZnp","quote":"Team_quote__shkEW","text":"Team_text__qe4aQ"};